import { formatDateForAPI } from "utils/utils";
import { getItemsFromCollection } from "directus/src/operations";

export async function fetchMonthlyDraftTimesheet(calendarStart, calendarEnd) {
  try {
    const query = {
      fields: ["id", "date", "logged_hours", "description", "department"],
      filter: {
        date: {
          _between: [
            formatDateForAPI(calendarStart),
            formatDateForAPI(calendarEnd),
          ],
        },
        employee: { user: { _eq: "$CURRENT_USER" } },
        logged_hours: { _gt: 0 },
      },
      limit: -1,
      sort: ["-date"],
    };

    const data = await getItemsFromCollection("draft_timesheet", query);
    return data;
  } catch (error) {
    console.error("Error fetching monthly draft timesheet:", error);
    throw error;
  }
}
